module.exports = __webpack_public_path__ + "static/media/QKC-BUSD.2af5223d.svg";